const envLabel =
  process.env.NODE_ENV === "production" ? "prod" : process.env.NODE_ENV === "test" ? "test" : "dev";

export const themeStorageKey = `agroproj-${envLabel}-theme`;

// Cookie name for sidebar state (used for SSR)
export const SIDEBAR_STATE_COOKIE = `agroproj-${envLabel}-sidebar-state`;

// Default sidebar state
export const SIDEBAR_DEFAULT_OPEN = true;
